// extracted by mini-css-extract-plugin
export default {"icon":"cartwidget_icon__-ZEQ5"};